export default "__VITE_ASSET__D_M89gJ$__"